export default "__VITE_ASSET__DAFOd7Lo__"